<template>

  <v-bottom-navigation
    app
    fixed
    grow
    v-model="activeItem"
    color="#bd595d"
    background-color="#FEF3C8"
  >
    <v-btn value="cal" :to="{ name: 'Calendrier'}">
      <v-icon>mdi-calendar</v-icon>
    </v-btn>

    <v-btn value="cont" :to="{ name: 'Contacts'}">
      <v-icon>mdi-contacts</v-icon>
    </v-btn>

    <v-btn  v-if="showButton2" value="plan" :to="{ name: 'Planning'}">
      <v-icon>mdi-calendar-month</v-icon>
    </v-btn>

    <v-btn  v-if="showButton" value="Alltcs" :to="{ name: 'Alltcs'}">
      <v-icon>mdi-calendar-account</v-icon>
    </v-btn>

    <v-btn value="logout" @click="logout()">
      <v-icon>mdi-exit-to-app</v-icon>
    </v-btn>
  </v-bottom-navigation>

</template>

<script>

export default {
  computed: {
    showButton () {
      return this.$store.state.showBottomNavButton // Liaison avec l'état Vuex
    },
    showButton2 () {
      return this.$store.state.showBottomNavButton2 // Liaison avec l'état Vuex
    }
  },

  data: () => ({
    activeItem: 'main',
    logout () {
      if (confirm('Étes vous sur de fermer votre session ?')) this.$store.dispatch('logout')
    }
  })

}
</script>



// WEBPACK FOOTER //
// src/components/BottomNav.vue